import IconLabel from './icon_label';

export default {
    icon_label: IconLabel,
};
